"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingPhotoEditor = void 0;
/* eslint-disable react/jsx-no-bind */
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const classnames_1 = __importDefault(require("classnames"));
const react_avatar_editor_1 = __importDefault(require("react-avatar-editor"));
const react_dropzone_1 = require("react-dropzone");
const AddPhotoAlternate_1 = __importDefault(require("@material-ui/icons/AddPhotoAlternate"));
const Redo_1 = __importDefault(require("@material-ui/icons/Redo"));
const Undo_1 = __importDefault(require("@material-ui/icons/Undo"));
const useStyle = core_1.makeStyles((theme) => ({
    root: {
        border: '1px dotted #9e9e9e',
        borderRadius: 5,
        textAlign: 'center',
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        padding: 30,
        fontSize: '0.8em',
        color: '#9e9e9e',
        '& div': {
            paddingBottom: 10
        }
    },
    active: {
        border: 1,
        color: '#9e9e9e',
        borderColor: '#9e9e9e',
        backgroundColor: '#eeeeee',
        borderStyle: 'solid'
    },
    link: {
        textDecoration: 'underline'
    },
    editImageLink: {
        fontSize: '0.8rem',
        display: 'block',
        textAlign: 'center',
        marginTop: 3,
        color: theme.palette.text.secondary
    }
}));
const SettingPhotoEditor = (props) => {
    const { label, photoUrl, description, handleValueChange } = props;
    const [isOpen, setIsOpen] = react_1.useState(false);
    const [isProcessing, setIsProcessing] = react_1.useState(false);
    const [image, setImage] = react_1.useState();
    const [zoom, setZoom] = react_1.useState(1);
    const [rotation, setRotation] = react_1.useState(0);
    const classes = useStyle();
    const editorRef = react_1.useRef(null);
    const onDrop = react_1.useCallback((dropped) => {
        setImage(dropped[0]);
    }, []);
    const { getRootProps, getInputProps, isDragActive } = react_dropzone_1.useDropzone({
        onDrop,
        accept: ['image/jpeg', 'image/png']
    });
    const handleClose = () => {
        setImage(undefined);
        setZoom(1);
        setIsOpen(false);
        setRotation(0);
    };
    const submit = async (e) => {
        setIsProcessing(true);
        if (handleValueChange && editorRef.current !== null) {
            const imgCanvas = editorRef.current.getImage();
            const blob = await new Promise((resolve) => imgCanvas.toBlob(resolve));
            if (blob !== null) {
                await handleValueChange(blob);
            }
        }
        handleClose();
        setIsProcessing(false);
    };
    const handleRotation = (clockwise = false) => {
        return () => {
            setRotation((r) => {
                return clockwise ? r + 90 : r - 90;
            });
        };
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(core_1.Dialog, { open: isOpen, onClose: handleClose, disableBackdropClick: true, disableEscapeKeyDown: true, maxWidth: "xs", fullWidth: true },
            react_1.default.createElement(core_1.DialogTitle, null,
                "Edit ",
                label),
            react_1.default.createElement(core_1.DialogContent, { dividers: true },
                description && react_1.default.createElement(core_1.DialogContentText, null, description),
                !image && (react_1.default.createElement("div", Object.assign({}, getRootProps(), { className: classnames_1.default(classes.root, { [classes.active]: isDragActive }) }),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(AddPhotoAlternate_1.default, null)),
                    react_1.default.createElement("div", null, "Drop an image here"),
                    react_1.default.createElement("div", null, "\u2014 or \u2014"),
                    react_1.default.createElement("div", { className: classes.link }, "Select an image from your computer"),
                    react_1.default.createElement("input", Object.assign({}, getInputProps())))),
                image && (react_1.default.createElement("div", { style: { width: 250, margin: '0 auto' } },
                    react_1.default.createElement(react_avatar_editor_1.default, { borderRadius: 100, image: image, scale: zoom, rotate: rotation, ref: editorRef }),
                    react_1.default.createElement(core_1.Grid, { container: true, spacing: 2, alignItems: "flex-start", justify: "space-between" },
                        react_1.default.createElement(core_1.Grid, { item: true, xs: true },
                            react_1.default.createElement(core_1.Typography, { display: "block", variant: "caption", color: "textSecondary" }, "Zoom"),
                            react_1.default.createElement(core_1.Slider, { disabled: isProcessing, min: 1, max: 3, step: 0.05, value: zoom, onChange: (e, v) => setZoom(v), style: { marginTop: 10 } })),
                        react_1.default.createElement(core_1.Grid, { item: true },
                            react_1.default.createElement(core_1.Typography, { display: "block", variant: "caption", color: "textSecondary" }, "Rotation"),
                            react_1.default.createElement(core_1.ButtonGroup, null,
                                react_1.default.createElement(core_1.IconButton, { disabled: isProcessing, onClick: handleRotation(false) },
                                    react_1.default.createElement(Undo_1.default, null)),
                                react_1.default.createElement(core_1.IconButton, { disabled: isProcessing, onClick: handleRotation(true) },
                                    react_1.default.createElement(Redo_1.default, null)))))))),
            react_1.default.createElement(core_1.DialogActions, null,
                react_1.default.createElement(core_1.Button, { onClick: handleClose, color: "primary", disabled: isProcessing }, "Cancel"),
                react_1.default.createElement(core_1.Button, { onClick: submit, color: "primary", disabled: isProcessing || !image }, "Save")),
            react_1.default.createElement(core_1.LinearProgress, { style: { visibility: isProcessing ? 'inherit' : 'hidden' } })),
        react_1.default.createElement(core_1.Grid, { container: true, justify: "space-between", alignItems: "center", onClick: () => setIsOpen(true), style: { cursor: 'pointer' } },
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(core_1.Typography, { display: "block", variant: "caption", color: "textSecondary" }, label),
                description && (react_1.default.createElement(core_1.Typography, { display: "block", color: "textSecondary" }, description))),
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(core_1.Avatar, { style: { width: 100, height: 100 }, src: photoUrl }),
                react_1.default.createElement(core_1.Typography, { className: classes.editImageLink }, "Edit the image")))));
};
exports.SettingPhotoEditor = SettingPhotoEditor;
//# sourceMappingURL=index.js.map